
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/california-consumer-privacy-policy-act",
      function () {
        return require("private-next-pages/california-consumer-privacy-policy-act/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/california-consumer-privacy-policy-act"])
      });
    }
  